import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  DialogActions,
} from "@mui/material";

// ✅ Esquema de validación con Yup
const schema = yup.object().shape({
  orgnom: yup.string().max(255, "Maximo 255 caracteres").required("El nombre es obligatorio"),
  orgdir: yup.string().max(255, "Maximo 255 caracteres"),
  orgtel: yup.string().matches(/^[0-9]+$/, "Solo se permiten números").max(50, "Maximo 50 caracteres"),
});

const OrganizationsForm = ({ open, handleClose, onSubmit, defaultValues = {} }) => {
  const isEditing = Boolean(defaultValues?.id);
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
  });

  // Resetear el formulario cuando cambia `defaultValues` o se cierra el modal
  useEffect(() => {
    if (open) {
      reset(defaultValues);
    }
  }, [open, defaultValues, reset]);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{isEditing ? "Editar Organización" : "Crear Organización"}</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          {/* Nombre de la Organización */}
          <TextField
            label="Nombre"
            fullWidth
            margin="normal"
            {...register("orgnom")}
            error={!!errors.orgnom}
            helperText={errors.orgnom?.message}
          />

          {/* Dirección */}
          <TextField
            label="Dirección"
            fullWidth
            margin="normal"
            {...register("orgdir")}
            error={!!errors.orgdir}
            helperText={errors.orgdir?.message}
          />

          {/* Teléfono */}
          <TextField
            label="Teléfono"
            fullWidth
            margin="normal"
            {...register("orgtel")}
            error={!!errors.orgtel}
            helperText={errors.orgtel?.message}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button type="submit" variant="contained">
            {isEditing ? "Actualizar" : "Guardar"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default OrganizationsForm;
